// custom typefaces
import './src/css/tailwind.css'
